<template>
  <div class="quick-filter">
    <b-form class="select_QuickFilter">
      <div id="cod-cliente-group" class="mt-1 mb-1 d-flex">
        <PFormSelect
          v-model="clienteSelected"
          :options="clientes"
          optionValue="id"
          optionText="codDesCliente"
          :label="$t('label.cliente')"
          :placeholder="$t('option.select')"
          variant="withoutBox"
          :disabled="!admin"
        />
      </div>
    </b-form>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { ICliente, IClienteAll, IDivisa } from "@/entities";
import { IVideoFilter } from "@/services";
import { todosCliente } from "@/constans";

@Component({
  name: "quick-filter",
})
export default class QuickFilter extends Vue {
  @Prop() public params!: IVideoFilter;
  @Action("setClienteSelected") setClienteSelected!: (cliente?: ICliente) => Promise<void>;

  @Getter("getClientesAll") getClientesAll!: IClienteAll[];
  @Getter("getClienteSelected") getClienteSelected!: ICliente;
  @Getter("getClienteXDivisa") getClienteXDivisa!: IDivisa[];

  private admin = false;
  private optionTodos = todosCliente;

  get clienteSelected(): number {
    let cliente = this.getClienteSelected;
    const clienteId = cliente?.id ?? this.params.pkCliente ?? this.optionTodos.id!;
    return this.getCliente(clienteId)?.id ?? this.optionTodos.id!;
  }

  set clienteSelected(clienteId: number) {
    if (clienteId && clienteId !== this.optionTodos.id) {
      this.setClienteSelected(this.getCliente(clienteId)).then(() => {
        return this.onChangeCliente(this.clienteSelected);
      });
    } else {
      this.setClienteSelected().then(() => {
        this.onChangeCliente();
      });
    }
  }

  getCliente(clienteId: number): ICliente {
    return this.clientes.find((cliente) => cliente.id === clienteId) as ICliente;
  }

  get clientes(): ICliente[] {
    const c = Object.assign([], this.getClientesAll);
    if (this.admin) {
      c.unshift(this.optionTodos);
    }
    return c;
  }

  public async mounted(): Promise<void> {
    this.admin = this.getClientesAll.length > 1;

    if (!this.getClienteSelected) {
      const idCliente = this.params.pkCliente ?? -1;
      const cliente = this.clientes.find((cliente) => cliente.id === idCliente);
      if (cliente && cliente.id !== -1) {
        await this.setClienteSelected(cliente);
      } else {
        await this.setClienteSelected();
      }
    }
  }

  async onChangeCliente(clienteId?: number): Promise<void> {
    if (clienteId && clienteId !== -1) {
      this.params.pkCliente = clienteId;
    } else {
      this.$emit("resetClient", true);
      delete this.params["pkCliente"];
    }

    this.$emit("action", { action: "quickFilter_client", data: null });
  }
}
</script>

<style lang="scss" scoped>
.material::v-deep .vs__dropdown-toggle {
  border: none;
  cursor: pointer;
}

.material::v-deep .vs__selected-options .vs__selected {
  padding-left: 0;
  margin-top: 0;
  margin-left: 0;
  font-size: 14px;
  color: #808080;
  font-weight: bold;
}

#input-cod-cliente-button {
  width: 150px;
  font-size: 12px;
  padding: 0;
  color: #979797;
  text-align: start;
}

#input-cod-cliente-icon {
  margin-left: 8px;
}

#input-cod-cliente {
  width: 150px;
}

.separator {
  width: 1px;
  height: 100%;
  border: solid 1px #e9e9e9;
}

#divisas-group {
  padding: 0 2em;
}

#input-divisas-label {
  font-size: 12px;
  line-height: 1.33;
  color: #979797;
}

#divisas-group > button {
  margin-right: 10px;
  width: 68px;
  height: 23px;
  object-fit: contain;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  padding-top: 0.15rem;
  padding-left: 16px;
  padding-right: 16px;
  color: var(--secundario-prosegur-oscuro);
  background-color: var(--fondo-not-active-toggle);
  border-color: var(--fondo-not-active-toggle);
}

#divisas-group > button.active {
  font-weight: 500;
  background-color: var(--amarillo-prosegur);
  border-color: var(--amarillo-prosegur);
}
.select_QuickFilter {
  display: flex !important;
  flex-direction: column;
}
</style>
